/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

const Redux = () => {
  
  const dispatch = useDispatch()
  
  const changeFilterPage = (page: number) =>
    dispatch({ type: 'changeFilterPage', payload: page })

  const changeFilterSize = (size: number) =>
    dispatch({ type: 'changeFilterSize', payload: size })
  
  const activeFilters = useSelector(store => store.Filter.activeFilters)

  return { 
    changeFilterPage, changeFilterSize,
    activeFilters,
  }
}

export default Redux
